/* eslint-disable global-require */
/* eslint-disable no-promise-executor-return */
/* eslint-disable consistent-return */
/* eslint-disable no-empty */
/* eslint-disable no-unused-vars */
/* eslint-disable no-debugger */
/* eslint-disable no-param-reassign */
import AWS from 'aws-sdk';
import { uploadFile } from 'react-s3';
import {
    awsRegion, s3Bucket, accessKeyId, secreteAccessKey,
} from '../../Components/config';
import { creatUUId } from './CreateUUID';

window.Buffer = window.Buffer || require('buffer').Buffer;

export const FileUpload = (file) => {
    const config = {
        bucketName: s3Bucket,
        region: awsRegion,
        accessKeyId,
        dirName: `certificate/${creatUUId()}`,
        secretAccessKey: secreteAccessKey,
    };
    uploadFile(file, config)
        .then((data) => data)
        .catch((err) => err);
};
